import React from 'react';
import { useBulkCustomSuggestionsActions } from 'modules/timesheet-labels/hooks/useBulkCustomSuggestionsActions';
import { BulkSuggestionMoreActions } from 'modules/timesheet-labels/BulkSuggestionMoreActions';

type CustomLabelMoreActionProps = {
  fieldName: string;
};
export const CustomLabelMoreAction: React.FC<CustomLabelMoreActionProps> = ({
  fieldName
}: CustomLabelMoreActionProps) => {
  const {
    enableCustomActions,
    denyAllCustomLabelSuggestionHandler
  } = useBulkCustomSuggestionsActions({ fieldName });

  return (
    <BulkSuggestionMoreActions
      enableActions={enableCustomActions}
      denyAllSuggestionHandler={denyAllCustomLabelSuggestionHandler}
      fieldName={fieldName}
    />
  );
};
